/* footer sticky reveal */

(function () {
  'use strict';

  var SECTION = '.yg-footer-section';
  var OFF = 'yg-footer-reveal-off';
  var MOBILE = '(max-width: 749px)';
  var OFF_SLACK = 24;
  var SETTLE = 60;
  var MAX_HOLD = 800;

  var root = document.documentElement;
  var spacer = document.querySelector('.yg-footer-reveal');
  if (!spacer) return;

  var section = null;
  var observer = null;
  var frame = 0;
  var frozen = false;
  var thaw = 0;

  /* lvh, not innerHeight: a phone's toolbar must not flip the reveal mid-scroll.
     Read through a registered property rather than a probe element - a fixed,
     viewport-tall probe sat over the announcement bar and left it unpainted
     until the first scroll on real phones. Unregistered, this computes to the
     literal "100lvh" and parseFloat's 100 loses to innerHeight. */
  var LVH = '--yg-lvh';
  try {
    CSS.registerProperty({ name: LVH, syntax: '<length>', inherits: false, initialValue: '0px' });
  } catch (e) {}
  root.style.setProperty(LVH, '100lvh');

  function viewport() {
    var lvh = parseFloat(getComputedStyle(root).getPropertyValue(LVH));
    return Math.max(lvh > 0 ? lvh : 0, window.innerHeight);
  }

  // an open mobile accordion is a transient height, not a reason to drop the reveal
  function expanded() {
    return window.matchMedia(MOBILE).matches && !!section.querySelector('details[open]');
  }

  function measure() {
    frame = 0;
    if (!section || frozen) return;

    var height = section.getBoundingClientRect().height;
    if (!height) return;
    spacer.style.setProperty('--yg-footer-h', height.toFixed(3) + 'px');

    var limit = viewport();
    var off = root.classList.contains(OFF);
    if (!off && height > limit + OFF_SLACK && !expanded()) root.classList.add(OFF);
    else if (off && height <= limit) root.classList.remove(OFF);
  }

  function queue() {
    if (frame) return;
    frame = requestAnimationFrame(measure);
  }

  // hold the document still while an accordion animates, then update once
  function hold() {
    frozen = true;
    clearTimeout(thaw);
    thaw = setTimeout(release, MAX_HOLD);
  }

  function settle() {
    if (!frozen) return;
    clearTimeout(thaw);
    thaw = setTimeout(release, SETTLE);
  }

  function release() {
    clearTimeout(thaw);
    frozen = false;
    queue();
  }

  function listen(el, on) {
    var method = on ? 'addEventListener' : 'removeEventListener';
    el[method]('toggle', hold, true);
    el[method]('transitionend', settle);
    el[method]('transitioncancel', settle);
  }

  function bind() {
    var next = document.querySelector(SECTION);

    if (!next) {
      if (observer) observer.disconnect();
      if (section) listen(section, false);
      observer = null;
      section = null;
      root.classList.add(OFF);
      return;
    }

    if (spacer.nextElementSibling !== next) next.parentNode.insertBefore(spacer, next);

    if (next !== section) {
      if (observer) observer.disconnect();
      if (section) listen(section, false);
      section = next;
      listen(section, true);
      if (window.ResizeObserver) {
        observer = new ResizeObserver(queue);
        observer.observe(section);
      }
    }

    clearTimeout(thaw);
    frozen = false;
    measure();
  }

  window.addEventListener('resize', queue);
  window.addEventListener('orientationchange', queue);
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', bind);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);

  bind();
})();
